// GENERATED by `npm run icons:sync` — do not edit by hand.
import { createLucideIcon } from 'lucide-react';

export const Tag = /*#__PURE__*/ createLucideIcon('Tag', [ [ "path", { d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z", key: "vktsd0" } ], ["circle", { cx: "7.5", cy: "7.5", r: ".5", fill: "currentColor", key: "kqv944" }] ]);
